import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import {Position, RowData, WarehouseData} from '../models/pallet-rack-interfaces';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatExpansionModule } from '@angular/material/expansion';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { PalletRacksModalComponent } from './pallet-racks-modal/pallet-racks-modal.component';

interface Position {
  position_uuid: string;
  packages: any[];
}

interface Area {
  inventory_area_uuid: string;
  positions: { [key: string]: Position };
}

interface RowData {
  inventory_row_uuid: string;
  total_positions: number;
  filled_positions: number;
  empty_positions: number;
  most_common_organization: string;
  areas: { [key: string]: Area };
}

interface WarehouseData {
  [key: string]: RowData;
}

@Component({
  selector: 'app-pallet-racks',
  templateUrl: './pallet-racks.component.html',
  styleUrls: ['./pallet-racks.component.scss']
})

export class PalletRacksComponent implements OnInit {

  @Input() selectedWarehouseUUID: string | null = '';

  public rows: any[] = [];
  hoverStates: { [positionUuid: string]: boolean } = {};
  constructor(private http: HttpClient, private dialog: MatDialog, private route: ActivatedRoute, private router: Router) { }

  uuid: string | null = ''
  warehouses!: any[]
  selectedWarehouse: string | null = null;

  ngOnInit() {
    console.log('input', this.selectedWarehouseUUID)

    this.route.paramMap.subscribe(params => {
      this.uuid = params.get('uuid');
    });

    // get list of warehouses
    const warehouse_url = "/api/inventory/inventory_warehouses.php"
    this.http.get(warehouse_url).subscribe((response: any) => {
      if (response) {
        console.log(response.data);
        this.warehouses = response.data;
      }
    })

    this.loadRackData();
  }

  loadRackData(): void {
    const url = `/api/inventory/inventory_warehouse_rows.php?uuid=${this.uuid}&req_type=alt`
    this.http.get<any>(url).subscribe(data => {
      this.rows = this.transformData(data);
      console.log('my rows', this.rows)
    });
  }

  transformData(data: WarehouseData): any[] {
    return Object.entries(data).map(([rowNumber, rowData]) => {
      const areas = Object.entries(rowData.areas).map(([section, sectionData]) => {
        const positions = Object.entries(sectionData.positions).map(([positionKey, positionValue]) => ({
          positionId: positionKey,
          ...positionValue,
        }));

        return {
          section,
          inventory_area_uuid: sectionData.inventory_area_uuid,
          positions,
        };
      });

      return {
        rowNumber,
        inventory_row_uuid: rowData.inventory_row_uuid,
        total_positions: rowData.total_positions,
        filled_positions: rowData.filled_positions,
        empty_positions: rowData.empty_positions,
        most_common_organization: rowData.most_common_organization,
        areas,
      };
    });
  }

  onWarehouseSelect(): void {
    if (this.selectedWarehouse) {
      this.router.navigate(['/inventory_management', this.selectedWarehouse]);
      this.uuid = this.selectedWarehouse
      this.loadRackData()
    }
  }

  // openModal(position: Position): void {
  //   // Open the modal dialog with the position details
  //   const dialogRef = this.dialog.open(PalletRacksModalComponent, {
  //     width: '400px',
  //     data: position
  //   });

  //   console.log(position)

  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log('The dialog was closed');
  //   });
  // }

}